import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import { Tooltip } from "@material-ui/core";

import { CustomWhatsappButton, CustomTitle } from "./styles/WhatsappButton";

export default function WhatsappButton({ celular }) {
  return (
    <CustomWhatsappButton>
      <a
        href={
          "https://api.whatsapp.com/send?phone=55" +
          (celular || "").replace(/[^0-9]+/g, "")
        }
        target="_blank"
        rel="noreferrer"
      >
        <Tooltip title={<CustomTitle>{celular}</CustomTitle>} arrow>
          <WhatsAppIcon alt="Whatsapp Icon" />
        </Tooltip>
      </a>
    </CustomWhatsappButton>
  );
}
